import { Component } from '@angular/core';

@Component({
  selector: 'app-checkout',
  standalone: false,

  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.scss'
})
export class CheckoutComponent {
  shippingAddress = '';
  paymentMethod = 'credit_card';

  onSubmit() {
    // Lógica de pago, etc.
    alert('¡Pedido realizado con éxito!');
  }
}